import { maybe } from "@saleor/misc";
import { OrderCourierEnum } from "@saleor/motherOrders/utils/enums";
import { useTableStyles } from "@saleor/remittanceRunner/styles/tableStyles";
import React from "react";

interface RemittanceRunnerTblColCompanyNameProp {
  dataTitle: string;
  isRider3pl: boolean;
  courier: string;
  companyName: string;
}

export const RemittanceRunnerTblColCompanyName: React.FC<RemittanceRunnerTblColCompanyNameProp> = props => {
  const { dataTitle, isRider3pl, courier, companyName } = props;
  const tblClasses = useTableStyles(props);

  const display3PLCompany = (() => {
    if (!courier) {
      return "";
    }

    if (courier.includes(OrderCourierEnum.GRAB)) {
      return OrderCourierEnum.GRAB;
    }

    if (courier.includes(OrderCourierEnum.PANDAGO)) {
      return OrderCourierEnum.PANDAGO;
    }

    return courier;
  })();

  const displayCompany = isRider3pl ? display3PLCompany : companyName;

  return (
    <div className={tblClasses.dataGroup}>
      <div className={tblClasses.dataTitle}>{dataTitle}</div>
      <div className={tblClasses.dataDisplay}>
        {maybe(() => displayCompany) ? (
          <span>{displayCompany}</span>
        ) : (
          <span>-----</span>
        )}
      </div>
    </div>
  );
};

export default RemittanceRunnerTblColCompanyName;
